<template>
  <div class="description" id="services">
    <div class="description-header-block">
      <div class="description-big-header">{{ $t('description.bigHeader') }}</div>
      <div class="description-small-header">{{ $t('description.smallHeader') }}</div>
    </div>
    <div class="description-scrum-block">
      <div class="scrum-block">
        <div class="scrum-block-header">{{ $t('description.leftBlock.header') }}</div>
        <div class="scrum-block-line"></div>
        <div class="scrum-block-text">{{ $t('description.leftBlock.text') }}</div>
        <div class="additional scrum-block">
          <div
            class="scrum-block-header additional-header"
          >{{ $t('description.rightBlock.header') }}</div>
          <div class="scrum-block-line"></div>
          <div class="scrum-block-text">{{ $t('description.rightBlock.text') }}</div>
        </div>
      </div>
      <div class="description-img-block">
        <img class="curly-img" src="../assets/img/left-curly.png" alt />
        <Scrum class="scrum-img" :width="width" />
        <img class="curly-img curly-right" src="../assets/img/right-curly.png" alt />
      </div>
      <div class="scrum-block scrum-right">
        <div class="scrum-block-header">{{ $t('description.rightBlock.header') }}</div>
        <div class="scrum-block-line"></div>
        <div class="scrum-block-text">{{ $t('description.rightBlock.text') }}</div>
      </div>
    </div>
    <ul class="description-platforms">
      <li v-for="platform in platforms" :key="platform.id">
        <div :class="`platform-img-comtainer mask mask${platform.id}`">
          <img :src="platform.img" alt="platform" />
          <!-- <svg>
            <use :xlink:href="platform.img"></use>
          </svg>-->
        </div>
        <div class="shadow"></div>
        <span>{{ platform.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { platforms } from "../configs/description";
import Scrum from "../components/Scrum";

export default {
  name: "description",
  components: {
    Scrum
  },
  props: {
    width: { type: Number, default: null }
  },
  data: () => {
    return {
      platforms
    };
  }
};
</script>

<style scoped lang="scss">
.description {
  background-image: url("../assets/img/description-back.svg");
  background-position-y: 79%;
  background-position-x: center;
  background-repeat: no-repeat;
  background-size: cover;
  // height: 123vh;     Обрезать картинку !!!


@media screen and (max-width: 1130px) {
      background-position-y: 100%;
  }

  @media screen and (max-width: 1012px) {
      background-position-y: -40%;
  }
}

.additional {
  display: none;

  @media screen and (max-width: 1012px) {
    display: initial;

    .scrum-block-header {
      margin-top: 45px;
    }
  }
}

.scrum-right {
  @media screen and (max-width: 1012px) {
    display: none;
  }
}

.description-header-block {
  padding-top: 150px;
  padding-bottom: 110px;

  @media screen and (max-width: 1130px) {
    padding-top: 90px;
    padding-bottom: 70px;
  }

  @media screen and (max-width: 1012px) {
    padding-top: 100px;
    padding-bottom: 70px;
  }

  @media screen and (max-width: 767px) {
    padding-top: 70px;
    padding-bottom: 50px;
  }

  @media screen and (max-width: 479px) {
    padding-bottom: 40px;
    padding-top: 60px;
  }

  @media screen and (max-width: 374px) {
    padding-bottom: 4%;
    padding-top: 12%;
  }
}

.description-big-header {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 24px;

  line-height: 100%;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;

  @media screen and (max-width: 1012px) {
    font-size: 20px;
  }

  @media screen and (max-width: 767px) {
    font-size: 18px;
  }

  @media screen and (max-width: 479px) {
    font-size: 14px;
  }
}

.description-small-header {
  font-family: Roboto;

  font-weight: bold;

  font-size: 60px;
  line-height: 100%;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;

  @media screen and (max-width: 1012px) {
    font-size: 56px;
  }

  @media screen and (max-width: 767px) {
    font-size: 48px;
  }
  @media screen and (max-width: 479px) {
    font-size: 36px;
  }
}

.description-img-block {
  display: flex;
  align-items: center;


  @media screen and (max-width: 767px) {
    margin: 0 auto;
  }

  @media screen and (max-width: 374px) {
    display: flex;
    justify-content: center;
  }
}

.description-scrum-block {
  display: flex;
  width: 1040px;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  @media screen and (max-width: 1130px) {
    max-width: 938px;
  }

  @media screen and (max-width: 1012px) {
    max-width: 624px;
  }

  @media screen and (max-width: 767px) {
    width: initial;
  }
}

.scrum-block {
  width: 207px;
  height: 147px;

  @media screen and (max-width: 1012px) {
    height: initial;
  }

  @media screen and (max-width: 767px) {
    display: none;
  }
}

.scrum-block-header {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  align-items: center;
  color: #ffffff;
}

.scrum-block-line {
  width: 50px;
  height: 1px;
  background: #ffffff;
  margin: 10px 0 10px 0;
}

.scrum-block-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #ffffff;
  opacity: 0.8;

  @media screen and (max-width: 1012px) {
    font-size: 14px;
    line-height: 130%;
  }
}

.curly-img {
  width: 34px;
  height: 431px;
  @media screen and (max-width: 1130px) {
    width: 26px;
    height: 359px;
  }

  @media screen and (max-width: 1012px) {
    height: 300px;
  }

  @media screen and (max-width: 767px) {
    display: none;
  }
}

.curly-right {
  @media screen and (max-width: 1012px) {
    display: none;
  }
}

.scrum-img {
  // width: 512px;
  // height: 431px;

  // @media screen and (max-width: 1130px) {
  //   width: 425px;
  //   height: 359.17px;
  // }

  @media screen and (max-width: 1012px) {
    max-width: 400px;
  }

  @media screen and (max-width: 767px) {
    display: flex;
    justify-content: center;
  }

  // @media screen and (max-width: 479px) {
  //   width: 340px;
  //   height: 290px;
  // }

  // @media screen and (max-width: 374px) {
  //   width: 91%;
  // }
}

.platform-img-comtainer {
  display: flex;
  justify-content: center;
  position: relative;
  width: 54px;
  margin: 0 auto;
  transition: 0.5s;
}

.mask {
  position: relative;
  // width: 100px;
  overflow: hidden;
  background-position: center;

  &:before {
    content: "";
    left: -30px;
    position: absolute;
    width: 10px;
    height: 100%;
    opacity: 0.5;
    background-color: #023a5a;
    transform: skew(-30deg);
    transition: 0.1s;
  }
}

.mask1 {
  mask: url("../assets/img/android-logo.svg") no-repeat center;
  mask-size: contain;
}

.mask2 {
  mask: url("../assets/img/apple-logo.svg") no-repeat center;
  mask-size: contain;
}

.mask3 {
  mask: url("../assets/img/cross-platform-logo.svg") no-repeat center;
  mask-size: contain;
}

.mask4 {
  mask: url("../assets/img/gear-logo.svg") no-repeat center;
  mask-size: contain;
}

@keyframes shine {
  100% {
    left: 110px;
  }
}

@keyframes lift {
  to {
    transform: scale(1.2);
  }
}

.shadow {
  position: absolute;
  width: 0;
  height: 5px;
  background: radial-gradient(50% 50% at 50% 50%, #1B516E 0%, rgba(28, 81, 111, 0) 100%);
  top: 60px;
  left: 50%;
  border-radius: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
  opacity: 0;
  z-index: 30;
  -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.description-platforms {
  padding-bottom: 28px;
  display: flex;
  width: 510px;
  margin: 90px auto 0 auto;
  justify-content: space-between;

  @media screen and (max-width: 1130px) {
    margin-top: 30px;
    padding-bottom: 5px;
  }

  @media screen and (max-width: 1012px) {
    padding-bottom: 21px;
    margin-top: 50px;
    width: 354px;
  }

  @media screen and (max-width: 767px) {
    width: 318px;
    margin: 48px auto 0;
    padding-bottom: 21px;
  }

  @media screen and (max-width: 479px) {
    margin: 37px auto 0;
    width: 221px;
  }

  @media screen and (max-width: 374px) {
    width: 200px;
    margin: 37px auto 0;
  }

  li {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 20%;
    img {

      opacity: 0.8;
    }

    &:hover {
      div:not(.shadow) {
        // animation: lift 0.8s ease-in-out forwards;
        transform: scale(1.3);
        img {
          opacity: 1;
        }
        &:before {
          animation: shine 0.6s linear forwards;
        }
      }
      .shadow {
        opacity: 0.5;
        animation: shadow .3s ease-in-out forwards;
      }
     
      span {
        opacity: 1;
      }
    }

    @keyframes shadow {
      to {
        width: 40px;
      }
    }

    @media screen and (max-width: 479px) {
      img {
        width: 36px;
        height: 36px;
      }
    }

    span {
      transition: 0.3s;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 19px;
      color: #ffffff;
      opacity: 0.5;
      height: 38px;
      text-align: center;
      margin-top: 25px;

      @media screen and (max-width: 1012px) {
        display: none;
      }

      @media screen and (max-width: 1130px) {
        margin-top: 15px;
      }
    }
  }
}
</style>
